module.exports = __webpack_public_path__ + "img/ic_qmarker_trailer_cluster_issue.d37c0258.png";